import React, { useContext } from "react";
import { Route } from "react-router";

import cssVars from "css-vars-ponyfill";

import { AppContext, AppContextProvider } from "./AppContext";

import RouteGuard from "./RouteGuard";

import LayoutComp from "./components/layout/LayoutComp";
import HomeComp from "./components/HomeComp";
import Login from "./components/login/LoginComp";
import Logout from "./components/login/LogoutComp";
import ForgotPassComp from "./components/login/ForgotPassComp";
import ResetPassComp from "./components/login/ResetPassComp";
import PreTradeComp from "./components/pretrade/PreTradeComp";
import ObaComp from "./components/oba/ObaComp";
import GiftComp from "./components/gift/GiftComp";
import AttestationComp from "./components/attestations/AttestationComp";
import AttestationFormComp from "./components/attestations/AttestationFormComp";
import DocumentComp from "./components/documents/DocumentComp";
import PoliticalComp from "./components/political/PoliticalComp";
import UserProfileComp from "./components/user/UserProfileComp";
import UserAccountComp from "./components/user/UserAccountComp";

import "@progress/kendo-theme-default/dist/all.css";

function App() {

  const AppContainerComp = () => {
    cssVars();

    const [appContext, setAppContext] = useContext(AppContext);
    
    return (
      <LayoutComp>
          <Route exact path="/" component={Login}/>
          <Route exact path="/login/:ssouser?" component={Login}/>
          <Route exact path="/logout" component={Logout}/>
          <Route exact path="/afterlogout" component={Logout}/>
          <Route exact path="/forgotpassword/:ssouser?" component={ForgotPassComp}/>
          <Route exact path="/resetpassword/:password_reset_token?" component={ResetPassComp}/>
          <RouteGuard exact path="/home" auth={appContext.auth} component={HomeComp}/>
          <RouteGuard exact path="/pretrade" component={PreTradeComp} auth={appContext.auth}/>
          <RouteGuard exact path="/oba/:id?/:t?" component={ObaComp} auth={appContext.auth}/>
          <RouteGuard exact path="/gift/:id?/:t?" component={GiftComp} auth={appContext.auth}/>
          <RouteGuard exact path="/political/:id?/:t?" component={PoliticalComp} auth={appContext.auth}/>
          <RouteGuard exact path="/attestation/:id" component={AttestationFormComp} auth={appContext.auth}/>
          <RouteGuard exact path="/attestation" component={AttestationComp} auth={appContext.auth}/>
          <RouteGuard exact path="/documents/:id?/:t?" component={DocumentComp} auth={appContext.auth}/>
          <RouteGuard exact path="/brokerage" component={UserAccountComp} auth={appContext.auth}/>
          <RouteGuard exact path="/profile" component={UserProfileComp} auth={appContext.auth}/>
      </LayoutComp>
    );
  };

  return (
    <AppContextProvider>
      <AppContainerComp />
    </AppContextProvider>
  );
}
export default App;
